import * as THREE from 'three';

/**
 * Creates and configures the root Three.js scene.
 * Background colour and fog are set here; lights are added separately.
 */
export function createScene(): THREE.Scene {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff);
  scene.fog = new THREE.Fog(0xffffff, 12, 40);
  return scene;
}
